import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  tableRow: {
    height: 24,
  },
  tableCell: {
    border: 'none',
    padding: 0,
    fontSize: pxToRem(14),
    letterSpacing: pxToEm(0.5, 14),
    lineHeight: pxToEm(24, 14),
    '&:first-child': {
      color: theme.palette.grey[700],
      paddingRight: 15,
      paddingLeft: 0,
    },
    '&:last-child': {
      paddingRight: 0,
    },
  },
});

const VendorInformation = props => (
  <Table>
    <TableBody>
      <TableRow className={props.classes.tableRow}>
        <TableCell className={props.classes.tableCell}>
          Vendor
        </TableCell>
        <TableCell
          className={props.classes.tableCell}
        >
          {props['Vendor Name']}
        </TableCell>
      </TableRow>
      {props.Email &&
        <TableRow className={props.classes.tableRow}>
          <TableCell className={props.classes.tableCell}>
            Email
          </TableCell>
          <TableCell
            className={props.classes.tableCell}
          >
            {props.Email}
          </TableCell>
        </TableRow>
      }
      {props['Mobile Phone'] &&
        <TableRow className={props.classes.tableRow}>
          <TableCell className={props.classes.tableCell}>
            Phone
          </TableCell>
          <TableCell
            className={props.classes.tableCell}
          >
            {props['Mobile Phone']}
          </TableCell>
        </TableRow>
      }
      {props['Contact Person'] &&
        <TableRow className={props.classes.tableRow}>
          <TableCell className={props.classes.tableCell}>
            Contact Person
          </TableCell>
          <TableCell
            className={props.classes.tableCell}
          >
            {props['Contact Person']}
          </TableCell>
        </TableRow>
      }
    </TableBody>
  </Table>
);

VendorInformation.propTypes = {
  'Vendor Name': PropTypes.string.isRequired,
  Email: PropTypes.string,
  'Mobile Phone': PropTypes.string,
  'Contact Person': PropTypes.string,
  classes: PropTypes.shape({
    tableCell: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
  }).isRequired,
};

VendorInformation.defaultProps = {
  Email: null,
  'Mobile Phone': null,
  'Contact Person': null,
};

export default withStyles(styles)(VendorInformation);



// WEBPACK FOOTER //
// ./src/components/vendor/VendorInformation/VendorInformation.js